module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.39b2c303.woff2";